<template>
    <div class="postal-picker">
        <label>Kod pocztowy</label>
        <input v-model="value.prefix" type="text" pattern="[0-9]*" inputmode="numeric" />
        -
        <input v-model="value.suffix" type="text" pattern="[0-9]*" inputmode="numeric" />
    </div>
</template>

<script>
    export default {
        name: "postal-picker",
        props: ['val'],
        mounted: function() {
            if(this.val) {
                this.value = this.val;
            }
        },
        data: function () {
            return {
                value: {
                    prefix: '',
                    suffix: ''
                }
            }
        },
        watch: {
            "val.prefix": function () {
                this.value.prefix = this.val.prefix;
            },
            "val.suffix": function () {
                this.value.suffix = this.val.suffix;
            },
            "value.prefix": function () {
                this.value.prefix = this.value.prefix.replace(/\D/g,'');
                this.value.prefix = this.value.prefix.substring(0, 2);
                this.$emit('input', this.value);
            },
            "value.suffix": function () {
                this.value.suffix = this.value.suffix.replace(/\D/g,'');
                this.value.suffix = this.value.suffix.substring(0, 3);
                this.$emit('input', this.value);
            }
        }
    }
</script>

<style scoped lang="scss">


</style>